<div class="tile-content">
  <div
    class="tile-body"
    [ngClass]="{ 'image-type': mediaType === 'image', 'video-type': mediaType === 'video' }">
    <a [href]="link" rel="noopener noreferrer nofollow">
      <ng-container [ngSwitch]="mediaType">
        <img *ngSwitchCase="'image'" [src]="mediaUrl" class="tile-media" alt="{{ title }}" />
        <app-video-container *ngSwitchCase="'video'" [embedUrl]="embedUrl" [title]="title">
        </app-video-container>
        <img
          *ngSwitchDefault
          src="/assets/img/default-placeholder.png"
          class="tile-media"
          alt="Default" />
      </ng-container>
    </a>
  </div>
  <div class="tile-footer">
    <a [href]="link" class="gen-neutral-black-link-underline" rel="noopener noreferrer nofollow">
      <h3 class="tile-title">{{ title }}</h3>
    </a>
    <p class="tile-description">{{ description }}</p>
  </div>
</div>
